<template>
  <svg width="800px" height="800px" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M14.2893 5.70711C13.8988 5.31658 13.2656 5.31658 12.8751 5.70711L7.98774 10.5994C7.20733 11.3805 7.20756 12.6463 7.98833 13.4271L12.8787 18.3175C13.2692 18.708 13.9024 18.708 14.2929 18.3175C14.6835 17.9269 14.6835 17.2938 14.2929 16.9032L10.1073 12.7176C9.71674 12.3271 9.71674 11.6939 10.1073 11.3034L14.2893 7.12132C14.6798 6.73079 14.6798 6.09763 14.2893 5.70711Z"
    />
  </svg>
</template>
<script setup></script>
